import { useState, useEffect } from "react";
import SummaryClasses from "./Summary.module.css";
import {
    Tax_Summary,
    getTaxSummaryNew,
    createPaymentLink,
} from "Services/Requests";
import Loader from "Components/Loader/loader";
import PaymentModal from "Components/Payments/PaymentModal";
import { showWarningAlert } from "Utils/Alerts";
import { useForm, SubmitHandler } from "react-hook-form";
import { useStore } from "Store";

interface Inputs {
    federal_payment: any;
    federal_value: any;
    itin_value: any;
    itin_payment: any;
    business_filing_value: any;
    business_filing_payment: any;
    election_value: any;
    election_payment: any;
    fbar_payment: any;
    fbar_value: any;
    fatca_value: any;
    fatca_payment: any;
    additional_fee_value: any;
    additional_fee_payment: any;
    other_fee_payment: any;
    other_fee_value: any;
    discount_price: any;
    discount_type: any;
    total: any;
    total_after_discount: any;
}

function TaxSummary() {
    const { isDisabled } = useStore((state: any) => state);

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>({
        defaultValues: {
            federal_payment: 0,
            federal_value: 0,
            itin_value: 0,
            itin_payment: 0,
            business_filing_value: 0,
            business_filing_payment: 0,
            election_value: 0,
            election_payment: 0,
            fbar_payment: 0,
            fbar_value: 0,
            fatca_value: 0,
            fatca_payment: 0,
            additional_fee_value: 0,
            additional_fee_payment: 0,
            other_fee_payment: 0,
            other_fee_value: 0,
            discount_price: 0,
            total: 0,
            total_after_discount: 0,
            discount_type: "$",
        },
    });
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState([]);
    const [newSummaries, setNewSummaries] = useState<any[]>([]);
    const [linkLoading, setLinkLoading] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState<any>(null);
    const [linkError, setLinkError] = useState<string | null>(null);
    const formData = watch();
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await Tax_Summary();

            setLoading(false);
            if (response.data.Status == 1) {
                // reset(response?.data?.taxsummary);
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team1"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    const GetNewSummaries = async () => {
        try {
            const taxId = localStorage.getItem("Year_id");
            if (!taxId) return;
            const res = await getTaxSummaryNew(taxId);
            console.log("Tax summaries:", res);
            if (res?.data?.Status == 1) {
                setPaymentDetails(res.data.data?.payment_details || null);
                setNewSummaries(res.data.data?.summaries || []);
            }
        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => {
        GetDetails();
        GetNewSummaries();
    }, []);

    const humanizeKey = (key: string) => {
        const s = key.replace(/_/g, " ");
        return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    };

    const isPositiveNumber = (v: any) => {
        return typeof v === "number" && !isNaN(v) && Number(v) !== 0;
    };

    const formatNumber = (v: any) => {
        if (v === null || v === undefined || v === "") return "";
        if (typeof v === "number") return v.toFixed(2);
        const n = Number(v);
        return isNaN(n) ? String(v) : n.toFixed(2);
    };

    const formatDate = (iso?: string) => {
        if (!iso) return "";
        try {
            const d = new Date(iso);
            if (isNaN(d.getTime())) return iso;
            const day = d.getUTCDate();
            const year = d.getUTCFullYear();
            const monthNames = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ];
            const month = monthNames[d.getUTCMonth()];
            const getOrdinal = (n: number) => {
                const s = ["th", "st", "nd", "rd"];
                const v = n % 100;
                return n + (s[(v - 20) % 10] || s[v] || s[0]);
            };
            return `${getOrdinal(day)} ${month} ${year}`;
        } catch (e) {
            return iso;
        }
    };

    const getStateField = (s: any, key: string) => {
        const st = s?.state;
        if (!st) return "";
        if (!Array.isArray(st)) {
            return st[key] !== undefined && st[key] !== null ? st[key] : "";
        }
        // st is array
        // for filing_status or other non-numeric fields, try to return a single value or comma-joined unique values
        if (key === "filing_status" || key === "for_value") {
            const vals = Array.from(
                new Set(
                    st
                        .map((x: any) => x[key])
                        .filter((v: any) => v !== undefined && v !== null)
                )
            );
            if (vals.length === 0) return "";
            return vals.length === 1 ? vals[0] : vals.join(", ");
        }
        // numeric fields: sum across states
        const sum = st.reduce((acc: number, x: any) => {
            const n = Number(x[key]);
            return acc + (isNaN(n) ? 0 : n);
        }, 0);
        return sum !== 0 ? sum : "";
    };

    const computeSummaryNumericTotal = (s: any) => {
        let total = 0;
        const add = (val: any) => {
            if (val === null || val === undefined || val === "") return;
            const n = Number(val);
            if (!isNaN(n)) total += n;
        };

        // federal
        if (s?.federal) {
            Object.values(s.federal).forEach((v: any) => add(v));
        }
        // state
        if (s?.state) {
            if (Array.isArray(s.state)) {
                s.state.forEach((st: any) =>
                    Object.values(st).forEach((v: any) => add(v))
                );
            } else {
                Object.values(s.state).forEach((v: any) => add(v));
            }
        }
        // filing_fee top-level numeric fields
        if (s?.filing_fee) {
            Object.entries(s.filing_fee).forEach(([k, v]: any) => {
                if (Array.isArray(v)) return;
                add(v);
            });
            // states array: sum state_fee + city_fee
            if (Array.isArray(s.filing_fee.states)) {
                s.filing_fee.states.forEach((st: any) => {
                    add(st.state_fee || 0);
                    add(st.city_fee || 0);
                });
            }
            // itins array: sum itin_fee
            if (Array.isArray(s.filing_fee.itins)) {
                s.filing_fee.itins.forEach((it: any) => add(it.itin_fee || 0));
            }
        }

        return total;
    };

    const getDisplayTotal = (s: any) => {
        const ff = s?.filing_fee || {};
        const total = ff.total;
        const after = ff.total_after_discount;
        const show =
            after !== undefined &&
            after !== null &&
            Number(after) !== 0 &&
            Number(after) !== Number(total)
                ? after
                : total;
        const n = Number(show);
        return isNaN(n) ? 0 : n;
    };

    // helpers to determine whether to show certain filing-fee rows
    const getVisibleFilingFeeKeys = () => {
        // collect all filing_fee keys across summaries, exclude array keys and known structural keys
        const exclude = new Set([
            "states",
            "cities",
            "itins",
            "additional_documents",
            "total",
            "total_after_discount",
            "grand_total",
            "discount",
            "discount_type",
        ]);
        const keys = new Set<string>();
        newSummaries.forEach((s: any) => {
            const ff = s?.filing_fee || {};
            Object.keys(ff).forEach((k) => {
                if (exclude.has(k)) return;
                if (Array.isArray((ff as any)[k])) return;
                keys.add(k);
            });
        });
        // filter to only those with non-null/non-zero numeric/string values
        return Array.from(keys).filter((k) =>
            newSummaries.some((s: any) => {
                const v = s?.filing_fee?.[k];
                if (v === undefined || v === null) return false;
                if (typeof v === "number") return !isNaN(v) && Number(v) !== 0;
                if (typeof v === "string") return v.trim() !== "";
                const n = Number(v);
                return !isNaN(n) && n !== 0;
            })
        );
    };

    const getDiscountAmount = (s: any) => {
        const ff = s?.filing_fee || {};
        const disc = ff.discount;
        const type = ff.discount_type;
        if (disc === undefined || disc === null) return 0;
        const n = Number(disc);
        if (isNaN(n) || n === 0) return 0;
        const base = Number(ff.total || 0);
        if (
            String(type).toLowerCase().includes("percent") ||
            String(type).toLowerCase().includes("%") ||
            String(type).toLowerCase() === "percentage"
        ) {
            return (base * n) / 100;
        }
        // otherwise treat as amount
        return n;
    };

    const hasAnyStateFees = () =>
        newSummaries.some(
            (s: any) =>
                Array.isArray(s.filing_fee?.states) &&
                s.filing_fee.states.some((st: any) => {
                    const a = Number(st.state_fee);
                    const b = Number(st.city_fee);
                    return (!isNaN(a) && a !== 0) || (!isNaN(b) && b !== 0);
                })
        );

    const hasAnyItinFees = () =>
        newSummaries.some(
            (s: any) =>
                Array.isArray(s.filing_fee?.itins) &&
                s.filing_fee.itins.some((it: any) => {
                    const n = Number(it.itin_fee);
                    return !isNaN(n) && n !== 0;
                })
        );

    const hasAnyCityFees = () =>
        newSummaries.some(
            (s: any) =>
                Array.isArray(s.filing_fee?.cities) &&
                s.filing_fee.cities.some((c: any) => {
                    const n = Number(c.city_fee);
                    return !isNaN(n) && n !== 0;
                })
        );

    const hasAnyAdditionalDocumentFees = () =>
        newSummaries.some(
            (s: any) =>
                Array.isArray(s.filing_fee?.additional_documents) &&
                s.filing_fee.additional_documents.some((d: any) => {
                    const n = Number(d.document_fee);
                    return !isNaN(n) && n !== 0;
                })
        );

    return (
        <div className={SummaryClasses["Container"]}>
            <form className={SummaryClasses["info"]}>
                <h3>Tax Summary</h3>
                {/* <table>
                    <thead>
                        <th>For</th>
                        <th>Refund/Due</th>
                        <th>Payment</th>
                    </thead>
                    <tbody>
                        {formData?.federal_payment > 0 && (
                            <tr>
                                <td>FEDERAL</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("federal_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("federal_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}

                        {formData?.itin_payment > 0 && (
                            <tr>
                                <td>ITIN</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("itin_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("itin_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.business_filing_payment > 0 && (
                            <tr>
                                <td>BUSINESS FILING</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("business_filing_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("business_filing_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.election_payment > 0 && (
                            <tr>
                                <td>ELECTION</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("election_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("election_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.fbar_payment > 0 && (
                            <tr>
                                <td>FBAR</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fbar_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fbar_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.fatca_payment > 0 && (
                            <tr>
                                <td>FACTA</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fatca_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("fatca_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.additional_fee_payment > 0 && (
                            <tr>
                                <td>ADDITIONAL FEE</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("additional_fee_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("additional_fee_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        {formData?.other_fee_payment > 0 && (
                            <tr>
                                <td>OTHER FEE</td>
                                <td>
                                    <input
                                        disabled
                                        {...register("other_fee_value")}
                                    />
                                </td>
                                <td>
                                    <input
                                        disabled
                                        {...register("other_fee_payment")}
                                        type="number"
                                    />
                                </td>
                            </tr>
                        )}
                        <tr>
                            <td>TOTAL </td>
                            <td></td>
                            <td>
                                <input disabled {...register("total")} />
                            </td>
                        </tr>
                        <tr>
                            <td>DISCOUNT</td>
                            <td></td>
                            <td>
                                <input
                                    disabled
                                    type="text"
                                    {...register("discount_price")}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td>TOTAL AFTER DISCOUNT</td>
                            <td colSpan={2}>
                                <input
                                    disabled
                                    {...register("total_after_discount")}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table> */}

                {/* Combined view: show federal values across tax types in columns */}
                {newSummaries && newSummaries.length > 0 ?(
                    <div style={{ marginTop: 12 }}>
                        <div className={SummaryClasses["summary-wrap"]}>
                            <div className={SummaryClasses["summary-left"]}>
                                <table
                                    className={SummaryClasses["summary-table"]}>
                                    <thead>
                                        <tr>
                                            <th>FOR</th>
                                            {newSummaries.map((s) => (
                                                <th key={s.tax_summary_type_id}>
                                                    {s.tax_type}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* rows order */}
                                        {[
                                            ["filing_status", "Filing status"],
                                            ["income", "Income"],
                                            [
                                                "taxable_income",
                                                "Taxable income",
                                            ],
                                            ["taxes", "Taxes"],
                                            ["credits", "Credits"],
                                            ["refund_or_due", "Refund or due"],
                                        ].map(([key, label]) => (
                                            <tr key={key}>
                                                <td>{label}</td>
                                                {newSummaries.map((s) => (
                                                    <td
                                                        key={
                                                            s.tax_summary_type_id +
                                                            "-" +
                                                            key
                                                        }>
                                                        <input
                                                            disabled
                                                            value={
                                                                s?.federal &&
                                                                s.federal[
                                                                    key
                                                                ] !== undefined
                                                                    ? s.federal[
                                                                          key
                                                                      ]
                                                                    : ""
                                                            }
                                                        />
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {/* State section (state-centric, matches admin layout) */}
                                <h4 style={{ marginTop: 10 }}>State</h4>
                                <div>
                                    {(() => {
                                        // build union of state names across summaries preserving order from first summary
                                        const names: string[] = [];
                                        newSummaries.forEach((s: any) => {
                                            (s.state || []).forEach(
                                                (st: any) => {
                                                    const nm =
                                                        st.state ||
                                                        st.state_name ||
                                                        st.State;
                                                    if (!nm) return;
                                                    if (!names.includes(nm))
                                                        names.push(nm);
                                                }
                                            );
                                        });

                                        return names.length === 0 ? (
                                            <div style={{ color: "#666" }}>
                                                No state data
                                            </div>
                                        ) : (
                                            names.map((stateName, idx) => (
                                                <table
                                                    className={
                                                        SummaryClasses[
                                                            "summary-table"
                                                        ]
                                                    }
                                                    key={stateName + "-" + idx}>
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                style={{
                                                                    width: 240,
                                                                }}>
                                                                <span
                                                                    style={{
                                                                        fontWeight:
                                                                            "500",
                                                                    }}>
                                                                    {stateName}
                                                                </span>
                                                            </th>
                                                            {newSummaries.map(
                                                                (s: any) => (
                                                                    <th
                                                                        key={
                                                                            s.tax_summary_type_id
                                                                        }
                                                                        style={{
                                                                            textAlign:
                                                                                "center",
                                                                        }}>
                                                                        {
                                                                            s.tax_type
                                                                        }
                                                                    </th>
                                                                )
                                                            )}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {[
                                                            [
                                                                "filing_status",
                                                                "Filing status",
                                                            ],
                                                            [
                                                                "income",
                                                                "Income",
                                                            ],
                                                            [
                                                                "taxable_income",
                                                                "Taxable income",
                                                            ],
                                                            ["taxes", "Taxes"],
                                                            [
                                                                "credits",
                                                                "Credits",
                                                            ],
                                                            [
                                                                "refund_or_due",
                                                                "Refund or due",
                                                            ],
                                                        ].map(
                                                            ([key, label]) => (
                                                                <tr
                                                                    key={
                                                                        stateName +
                                                                        "-" +
                                                                        key
                                                                    }>
                                                                    <td>
                                                                        {label}
                                                                    </td>
                                                                    {newSummaries.map(
                                                                        (
                                                                            s: any
                                                                        ) => {
                                                                            const st =
                                                                                (Array.isArray(
                                                                                    s.state
                                                                                )
                                                                                    ? s.state.find(
                                                                                          (
                                                                                              x: any
                                                                                          ) =>
                                                                                              (x.state ||
                                                                                                  x.state_name ||
                                                                                                  x.State) ===
                                                                                              stateName
                                                                                      )
                                                                                    : s.state) ||
                                                                                {};
                                                                            const val =
                                                                                st
                                                                                    ? st[
                                                                                          key
                                                                                      ] ??
                                                                                      st[
                                                                                          key as any
                                                                                      ] ??
                                                                                      ""
                                                                                    : "";
                                                                            return (
                                                                                <td
                                                                                    key={
                                                                                        s.tax_summary_type_id +
                                                                                        "-" +
                                                                                        stateName +
                                                                                        "-" +
                                                                                        key
                                                                                    }>
                                                                                    <input
                                                                                        disabled
                                                                                        value={
                                                                                            key ===
                                                                                            "filing_status"
                                                                                                ? val ||
                                                                                                  ""
                                                                                                : formatNumber(
                                                                                                      val ??
                                                                                                          ""
                                                                                                  )
                                                                                        }
                                                                                    />
                                                                                </td>
                                                                            );
                                                                        }
                                                                    )}
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            ))
                                        );
                                    })()}
                                </div>

                                {/* Filing fee summary - show selected numeric fields */}
                                <h4 style={{ marginTop: 10 }}>Filing Fee</h4>
                                <table
                                    className={SummaryClasses["summary-table"]}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            {newSummaries.map((s) => (
                                                <th
                                                    key={
                                                        "ff-" +
                                                        s.tax_summary_type_id
                                                    }>
                                                    {s.tax_type}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getVisibleFilingFeeKeys().map((k) => (
                                            <tr key={k}>
                                                <td>{humanizeKey(k)}</td>
                                                {newSummaries.map((s) => {
                                                    const v = s?.filing_fee
                                                        ? s.filing_fee[k]
                                                        : undefined;
                                                    return (
                                                        <td
                                                            key={
                                                                s.tax_summary_type_id +
                                                                "-ff-" +
                                                                k
                                                            }>
                                                            {v !== undefined &&
                                                            v !== null &&
                                                            Number(v) !== 0 ? (
                                                                <input
                                                                    disabled
                                                                    value={formatNumber(
                                                                        v
                                                                    )}
                                                                />
                                                            ) : null}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        ))}

                                        {/* totals moved to bottom after arrays */}

                                        {hasAnyStateFees() && (
                                            <tr>
                                                <td>State Fees (sum)</td>
                                                {newSummaries.map((s) => (
                                                    <td
                                                        key={
                                                            "stsum-" +
                                                            s.tax_summary_type_id
                                                        }>
                                                        {Array.isArray(
                                                            s.filing_fee?.states
                                                        ) &&
                                                        s.filing_fee.states
                                                            .length > 0
                                                            ? s.filing_fee.states.map(
                                                                  (
                                                                      st: any,
                                                                      i: number
                                                                  ) => (
                                                                      <div
                                                                          key={
                                                                              i
                                                                          }
                                                                          style={{
                                                                              display:
                                                                                  "flex",
                                                                              gap: 8,
                                                                              alignItems:
                                                                                  "center",
                                                                              marginBottom: 6,
                                                                          }}>
                                                                          <div
                                                                              style={{
                                                                                  minWidth: 120,
                                                                              }}>
                                                                              {
                                                                                  st.state_name
                                                                              }
                                                                          </div>
                                                                          <input
                                                                              disabled
                                                                              value={formatNumber(
                                                                                  st.state_fee ??
                                                                                      0
                                                                              )}
                                                                          />
                                                                      </div>
                                                                  )
                                                              )
                                                            : null}
                                                    </td>
                                                ))}
                                            </tr>
                                        )}

                                        {hasAnyItinFees() && (
                                            <tr>
                                                <td>ITIN Fees</td>
                                                {newSummaries.map((s) => (
                                                    <td
                                                        key={
                                                            "itsum-" +
                                                            s.tax_summary_type_id
                                                        }>
                                                        {Array.isArray(
                                                            s.filing_fee?.itins
                                                        ) &&
                                                        s.filing_fee.itins
                                                            .length > 0
                                                            ? s.filing_fee.itins.map(
                                                                  (
                                                                      it: any,
                                                                      i: number
                                                                  ) =>
                                                                      it.itin_fee &&
                                                                      Number(
                                                                          it.itin_fee
                                                                      ) !==
                                                                          0 ? (
                                                                          <div
                                                                              key={
                                                                                  i
                                                                              }
                                                                              style={{
                                                                                  display:
                                                                                      "flex",
                                                                                  gap: 8,
                                                                                  alignItems:
                                                                                      "center",
                                                                                  marginBottom: 6,
                                                                              }}>
                                                                              <div
                                                                                  style={{
                                                                                      minWidth: 120,
                                                                                  }}>
                                                                                  {
                                                                                      it.itin_name
                                                                                  }
                                                                              </div>
                                                                              <input
                                                                                  disabled
                                                                                  value={formatNumber(
                                                                                      it.itin_fee
                                                                                  )}
                                                                              />
                                                                          </div>
                                                                      ) : null
                                                              )
                                                            : null}
                                                    </td>
                                                ))}
                                            </tr>
                                        )}

                                        {hasAnyCityFees() && (
                                            <tr>
                                                <td>City Fees</td>
                                                {newSummaries.map((s) => (
                                                    <td
                                                        key={
                                                            "citysum-" +
                                                            s.tax_summary_type_id
                                                        }>
                                                        {Array.isArray(
                                                            s.filing_fee?.cities
                                                        ) &&
                                                        s.filing_fee.cities
                                                            .length > 0
                                                            ? s.filing_fee.cities.map(
                                                                  (
                                                                      c: any,
                                                                      i: number
                                                                  ) => (
                                                                      <div
                                                                          key={
                                                                              i
                                                                          }
                                                                          style={{
                                                                              display:
                                                                                  "flex",
                                                                              gap: 8,
                                                                              alignItems:
                                                                                  "center",
                                                                              marginBottom: 6,
                                                                          }}>
                                                                          <div
                                                                              style={{
                                                                                  minWidth: 120,
                                                                              }}>
                                                                              {
                                                                                  c.city_name
                                                                              }
                                                                          </div>
                                                                          <input
                                                                              disabled
                                                                              value={formatNumber(
                                                                                  c.city_fee ??
                                                                                      0
                                                                              )}
                                                                          />
                                                                      </div>
                                                                  )
                                                              )
                                                            : null}
                                                    </td>
                                                ))}
                                            </tr>
                                        )}

                                        {hasAnyAdditionalDocumentFees() && (
                                            <tr>
                                                <td>Additional Documents</td>
                                                {newSummaries.map((s) => (
                                                    <td
                                                        key={
                                                            "adddoc-" +
                                                            s.tax_summary_type_id
                                                        }>
                                                        {Array.isArray(
                                                            s.filing_fee
                                                                ?.additional_documents
                                                        ) &&
                                                        s.filing_fee
                                                            .additional_documents
                                                            .length > 0
                                                            ? s.filing_fee.additional_documents.map(
                                                                  (
                                                                      d: any,
                                                                      i: number
                                                                  ) => (
                                                                      <div
                                                                          key={
                                                                              i
                                                                          }
                                                                          style={{
                                                                              display:
                                                                                  "flex",
                                                                              gap: 8,
                                                                              alignItems:
                                                                                  "center",
                                                                              marginBottom: 6,
                                                                          }}>
                                                                          <div
                                                                              style={{
                                                                                  minWidth: 120,
                                                                              }}>
                                                                              {
                                                                                  d.document_name
                                                                              }
                                                                          </div>
                                                                          <input
                                                                              disabled
                                                                              value={formatNumber(
                                                                                  d.document_fee ??
                                                                                      0
                                                                              )}
                                                                          />
                                                                      </div>
                                                                  )
                                                              )
                                                            : null}
                                                    </td>
                                                ))}
                                            </tr>
                                        )}
                                        {/* Discount amount row (computed) and totals - placed after array rows */}

                                        <tr>
                                            <td>TOTAL</td>
                                            {newSummaries.map((s) => (
                                                <td
                                                    key={
                                                        s.tax_summary_type_id +
                                                        "-total"
                                                    }>
                                                    {s?.filing_fee?.total !==
                                                        undefined &&
                                                    s.filing_fee.total !==
                                                        null &&
                                                    Number(
                                                        s.filing_fee.total
                                                    ) !== 0 ? (
                                                        <input
                                                            disabled
                                                            value={formatNumber(
                                                                s.filing_fee
                                                                    .total
                                                            )}
                                                        />
                                                    ) : null}
                                                </td>
                                            ))}
                                        </tr>
                                        {/* show discount row only when there is a non-zero discount */}
                                        {newSummaries.some((s: any) => {
                                            const da = getDiscountAmount(s);
                                            return (
                                                !isNaN(Number(da)) &&
                                                Number(da) !== 0
                                            );
                                        }) && (
                                            <tr>
                                                <td>Discount</td>
                                                {newSummaries.map((s) => {
                                                    const da =
                                                        getDiscountAmount(s);
                                                    const show =
                                                        !isNaN(Number(da)) &&
                                                        Number(da) !== 0;
                                                    return (
                                                        <td
                                                            key={
                                                                s.tax_summary_type_id +
                                                                "-discount"
                                                            }>
                                                            {show ? (
                                                                <input
                                                                    disabled
                                                                    value={formatNumber(
                                                                        da
                                                                    )}
                                                                />
                                                            ) : null}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        )}
                                        {/* show TOTAL AFTER DISCOUNT row only when at least one summary has a non-zero different value */}
                                        {newSummaries.some((s: any) => {
                                            const tad =
                                                s?.filing_fee
                                                    ?.total_after_discount;
                                            const tot = s?.filing_fee?.total;
                                            return (
                                                tad !== undefined &&
                                                tad !== null &&
                                                !isNaN(Number(tad)) &&
                                                Number(tad) !== 0 &&
                                                Number(tad) !== Number(tot)
                                            );
                                        }) && (
                                            <tr>
                                                <td>TOTAL AFTER DISCOUNT</td>
                                                {newSummaries.map((s) => (
                                                    <td
                                                        key={
                                                            s.tax_summary_type_id +
                                                            "-total-after"
                                                        }>
                                                        {s?.filing_fee
                                                            ?.total_after_discount !==
                                                            undefined &&
                                                        s.filing_fee
                                                            .total_after_discount !==
                                                            null &&
                                                        !isNaN(
                                                            Number(
                                                                s.filing_fee
                                                                    .total_after_discount
                                                            )
                                                        ) &&
                                                        Number(
                                                            s.filing_fee
                                                                .total_after_discount
                                                        ) !== 0 &&
                                                        Number(
                                                            s.filing_fee
                                                                .total_after_discount
                                                        ) !==
                                                            Number(
                                                                s.filing_fee
                                                                    .total
                                                            ) ? (
                                                            <input
                                                                disabled
                                                                value={formatNumber(
                                                                    s.filing_fee
                                                                        .total_after_discount
                                                                )}
                                                            />
                                                        ) : null}
                                                    </td>
                                                ))}
                                            </tr>
                                        )}

                                        <tr>
                                            <td>GRAND TOTAL</td>
                                            {newSummaries.map((s) => (
                                                <td
                                                    key={
                                                        s.tax_summary_type_id +
                                                        "-grand"
                                                    }>
                                                    {s?.filing_fee
                                                        ?.grand_total !==
                                                        undefined &&
                                                    s.filing_fee.grand_total !==
                                                        null &&
                                                    Number(
                                                        s.filing_fee.grand_total
                                                    ) !== 0 ? (
                                                        <input
                                                            disabled
                                                            value={formatNumber(
                                                                s.filing_fee
                                                                    .grand_total
                                                            )}
                                                        />
                                                    ) : null}
                                                </td>
                                            ))}
                                        </tr>
                                    </tbody>
                                </table>

                                {/* Grand total below tables, right aligned */}
                                <div
                                    className={
                                        SummaryClasses["grand-total-row"]
                                    }>
                                    <div
                                        className={
                                            SummaryClasses["grand-total"]
                                        }>
                                        <div
                                            className={
                                                SummaryClasses[
                                                    "grand-total-label"
                                                ]
                                            }>
                                            Grand Total
                                        </div>
                                        <div
                                            className={
                                                SummaryClasses[
                                                    "grand-total-value"
                                                ]
                                            }>
                                            {formatNumber(
                                                newSummaries.reduce(
                                                    (acc: number, s: any) =>
                                                        acc +
                                                        getDisplayTotal(s),
                                                    0
                                                )
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ):<p>No Summary Found</p>}

                <div style={{ marginTop: 12 }}>
                    {/* Only show payment details when payment is RECEIVED */}
                    {paymentDetails && newSummaries.length > 0 &&
                    paymentDetails.payment_status === "received" ? (
                        <div
                            style={{
                                padding: 12,
                                borderRadius: 8,
                                marginBottom: 10,
                                border: `1px solid #2e7d32`,
                                background: "#e8f5e9",
                                color: "#1b5e20",
                            }}>
                            <div style={{ fontSize: 14, lineHeight: 1.4 }}>
                                {/**
                                 * Example sentence: "Your payment of $175.00 was received on 25th May 2025 (Transaction ID: pi_...)."
                                 */}
                                <strong>Your payment of</strong>{" "}
                                <strong>
                                    $
                                    {formatNumber(
                                        paymentDetails.payment_amount
                                    )}
                                </strong>{" "}
                                <span>was received on</span>{" "}
                                <strong>
                                    {formatDate(
                                        paymentDetails.payment_completed_at
                                    )}
                                </strong>
                                {paymentDetails.transaction_id ? (
                                    <span>
                                        {" "}
                                        (Transaction ID:{" "}
                                        {paymentDetails.transaction_id})
                                    </span>
                                ) : null}
                                .
                            </div>
                        </div>
                    ) : null}

                    {/* Show button only when payment is NOT received (including when no paymentDetails or pending) */}
                    {!(
                        paymentDetails &&
                        paymentDetails.payment_status === "received"
                    ) && (
                        <>
                            <button
                                type="button"
                                disabled={
                                    isDisabled ||
                                    newSummaries.length === 0 ||
                                    newSummaries.reduce(
                                        (acc: number, s: any) =>
                                            acc + getDisplayTotal(s),
                                        0
                                    ) === 0 ||
                                    linkLoading
                                }
                                onClick={async () => {
                                    setLinkError(null);
                                    try {
                                        setLinkLoading(true);
                                        const amount = Number(
                                            newSummaries
                                                .reduce(
                                                    (acc: number, s: any) =>
                                                        acc +
                                                        getDisplayTotal(s),
                                                    0
                                                )
                                                .toFixed(2)
                                        );
                                        const res = await createPaymentLink({
                                            amount,
                                            currency: "usd",
                                            tax_file_year_id:
                                                localStorage.getItem("Year_id"),
                                            description: "Tax payment",
                                        });
                                        const data = res?.data || res;
                                        const paymentUrl =
                                            data?.data?.payment_url ||
                                            data?.payment_url ||
                                            data?.data?.url;
                                        if (paymentUrl) {
                                            const sessionId =
                                                data?.data?.session_id ||
                                                data?.session_id ||
                                                data?.data?.id;
                                            try {
                                                if (sessionId)
                                                    localStorage.setItem(
                                                        "checkout_session_id",
                                                        String(sessionId)
                                                    );
                                                localStorage.setItem(
                                                    "checkout_amount",
                                                    String(amount)
                                                );
                                            } catch (e) {
                                                // ignore storage errors
                                            }
                                            window.location.href = paymentUrl;
                                        } else {
                                            setLinkError(
                                                "Failed to create payment link"
                                            );
                                        }
                                    } catch (err: any) {
                                        setLinkError(
                                            err?.response?.data?.Message ||
                                                err.message ||
                                                "Error creating payment link"
                                        );
                                    } finally {
                                        setLinkLoading(false);
                                    }
                                }}>
                                {linkLoading
                                    ? "Opening Checkout…"
                                    : "Pay with Checkout"}
                            </button>
                            {linkError && (
                                <div style={{ color: "#b00020", marginTop: 8 }}>
                                    {linkError}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </form>
        </div>
    );
}

export default TaxSummary;
